import React, { useEffect, useState } from 'react';
import CusPageContainer from '../../../../components/shared/CusPageContainer';
import ChildCard from '../../../../components/shared/ChildCard';
import { useTranslation } from 'react-i18next';
import CusInput from '../../../../components/material-ui/CusInput';
import { Box, Stack, Typography } from '@mui/material';
import CusButton from '../../../../components/material-ui/CusButton';
import CusLink from '../../../../components/material-ui/CusLink';
import { useNavigate, useParams } from 'react-router';
import useColor from '../../../../hooks/site/useColor';
import useGroupByGroupId from '../../../../hooks/site/useGroupByGroupId';
import { API_GROUP } from '../../../../api/user';
import { useDispatch } from 'react-redux';
import { setPostback } from '../../../../store/apps/groupInfoSlice';
import useToast from '../../../../hooks/useToast';
import { useAppSelector } from '../../../../store';

export default function PostbackLink() {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { successToast } = useToast();
  const { group, groupId } = useGroupByGroupId();
  const { error } = useColor();

  const postbackInfo = useAppSelector((state) => state.groupInfo.postback?.[groupId]) || {};

  useEffect(() => {
    console.log('postbackInfo', postbackInfo);
    if (postbackInfo.register) setRegisterUrl(postbackInfo.register);
  }, [postbackInfo.register]);
  useEffect(() => {
    if (postbackInfo.deposit) setDepositUrl(postbackInfo.deposit);
  }, [postbackInfo.deposit]);

  const [registerUrl, setRegisterUrl] = useState('');
  const [depositUrl, setDepositUrl] = useState('');

  const TypographyList = [
    { id: 'user_id', label: 'Numeric user ID', mt: 1 },
    { id: 'ref_code', label: 'Group referral code' },
    {
      id: 'is_site',
      label: 'true if the event occurred on the site, or false if the event occurred in the bot'
    },
    {
      id: 'tid',
      label: 'Random parameter, always a unique value, which is added to each postback call'
    },
    {
      description: 'When calling PB, additional amounts will be transferred for each deposit.',
      mt: 0.75
    },
    { id: 'amount', label: 'Deposit amount' },
    { id: 'currency', label: '3-character deposit currency code' }
  ];

  useEffect(() => {
    API_GROUP.postback
      .list({ groupId })
      .then((e) => {
        const data = e.data.data;
        console.log(e.data);

        dispatch(setPostback({ groupId, data }));
      })
      .catch(console.log);
  }, [groupId]);

  const onSave = () => {
    API_GROUP.postback
      .set({ groupId, register: registerUrl, deposit: depositUrl })
      .then((e) => {
        console.log(e);

        // navigate(`/affiliate/${groupId}/referral`);
        dispatch(setPostback({ groupId, data: { register: registerUrl, deposit: depositUrl } }));
        successToast('Postback saved successfully');
      })
      .catch(console.log);
  };

  return (
    <CusPageContainer title="Postback links" group={group} loader={!group}>
      <ChildCard title={t('Postback (PB)')}>
        <Stack display={'flex'} flexDirection={'column'} gap={1}>
          <CusInput
            label={t('PB URL for player registration')}
            value={registerUrl}
            onChange={(e) => setRegisterUrl(e.target.value)}
            placeholder={'https://your-domain.tld/postback-script-name?action=join'}
            isTranslatePlaceholder={false}
          />
          <CusInput
            label={t('PB URL for each player deposit')}
            value={depositUrl}
            onChange={(e) => setDepositUrl(e.target.value)}
            placeholder={'https://your-domain.tld/postback-script-name?action=deposit'}
            isTranslatePlaceholder={false}
          />

          <Stack display={'flex'} flexDirection={'row'} alignItems="center">
            <CusButton text="Save" onClick={onSave} />
            <CusLink text={'Referral links'} to={`/affiliate/${groupId}/referral`} ml={'auto'} />
          </Stack>
        </Stack>

        <Stack mt={2} display={'flex'} flexDirection={'column'}>
          <Box p={1} bgcolor={error.main} my={1}>
            <Typography fontWeight={600} color="textPrimary">
              {t(
                'Also when all parameters received from the referral link will be automatically added to each PB URL'
              )}
            </Typography>
          </Box>
          <Typography variant="h5">
            {t('When calling PB, GET parameters will be additionally passed')}
          </Typography>

          {TypographyList.map((info) => (
            <Typography variant="inherit" mt={info.mt} color="textDisabled">
              {info.description ? (
                t(info.description)
              ) : (
                <>
                  <Typography fontWeight={600} color="textPrimary" component={'span'}>
                    {info.id}
                  </Typography>{' '}
                  - {t(info.label)}
                </>
              )}
            </Typography>
          ))}
        </Stack>
      </ChildCard>
    </CusPageContainer>
  );
}
